import * as React from 'react';
import cn from 'classnames';
import { FC } from 'react';
import { useTheme } from '../../../theme';

interface Props {
	className?: string;
}
export const Card: FC<Props> = ({ children, className }) => {
	const { Card: theme } = useTheme('InsurancePage');

	return <div className={cn(theme.card, className)}>{children}</div>;
};
